import { faEraser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip } from '@mui/material'
import { getTestId } from '@utils/helpers'

export default function DirectDealRejectedChip({ ...rest }: { 'data-testid'?: string }) {
	const testId = getTestId(rest, 'direct-deal-rejected-chip')
	const chipColor = 'error.main'

	return (
		<Chip
			icon={<FontAwesomeIcon icon={faEraser} color="white" />}
			label="Direct Deal Rejected"
			data-testid={testId}
			sx={{
				width: 'fit-content',
				color: 'white',
				bgcolor: chipColor,
			}}
		/>
	)
}
